import { IAppUserInfo } from "@/types/app-user";
import { useUserInfoStore } from "@/stores/user-info";
import { isHelloTalk, getAppUserInfo } from "@ht/utils/src";
import { MOCK_USER_INFO } from "@/mock/native-user-info";

// 获取App用户信息
export const getUserInfo = async (): Promise<IAppUserInfo> => {
  return await new Promise(async resolve => {
    // 如果是HelloTalk环境，调用HelloTalk的接口获取用户信息
    if (isHelloTalk()) {
      console.log(
        `%c当前环境-[App内]-[${import.meta.env.MODE}]`,
        "color: green"
      );
      await getAppUserInfo().then(async res => {
        if (res) {
          console.log("[App 用户信息:]", res);
          await resolve(res);
        }
      });
      // 如果不是HelloTalk环境，或者本地开发，使用本地模拟数据
    } else if (__LOCAL__ && !isHelloTalk()) {
      setTimeout(() => {
        console.log(
          `%c当前环境-[App外或者LOCAL环境]-[${import.meta.env.MODE}]`,
          "color: green"
        );
      }, 3 * 3e3);
      // 使用本地模拟数据
      resolve(MOCK_USER_INFO);
    } else {
      // 其他情况，返回空对象
      resolve({});
    }
  });
};

export async function initAppConfig() {
  //获取App信息，设置到store中
  await Promise.all([getUserInfo()]).then(([user]) => {
    const userInfoStore = useUserInfoStore();
    userInfoStore.setUser(user);
  });
}
